// Generated by GitHub Copilot
import { createFileRoute } from '@tanstack/react-router'
import { SecurityPanel } from '#components/entities/users/security/security-panel.tsx'

export const Route = createFileRoute('/settings/security')({
  component: SecurityPanel,
})
